









































































































import { User } from '@/api/Auth/auth.interface'
import { Params } from '@/utils/interfaces'
import {
  getTopUpAgents,
  createAgentConfiguration,
  updateAgentPrices,
  getTopUpAgentById,
} from '@/api/Topup/topup.api'
import CreateConfiguration from '@/components/Services/TopUps/CreateConfiguration.vue'
import ActionButton from '@/components/ActionButton.vue'
import {
  TopUpAgent,
  TopUpPrice,
  RemoveCreditDTO,
} from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import TreeviewButton from './TreeviewButton.vue'
import MySettings from './MySettings.vue'
import mixins from 'vue-typed-mixins'
import topUpPriceMixin from '@/utils/mixins/topUpPriceMixin'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default mixins(tableHandler<TopUpAgent>(), topUpPriceMixin).extend({
  components: {
    appUsersFilter: UsersFilter,
    appCreateConfiguration: CreateConfiguration,
    appActionButton: ActionButton,
    appTreeviewButton: TreeviewButton,
    MySettings,
    FlatCard,
    FlatTable,
    TextButton,
  },
  props: {
    exit: Object,
  },
  data() {
    return {
      selected: [] as TopUpAgent[],
      filterModel: false,
      items: [] as User[],
      loadingConfig: false,
      editedItem: null as null | User,
      creatingItem: null as null | TopUpAgent,
      field: 'cost' as 'price' | 'cost',
      exitCard: false,
      mySettings: {
        cost: 0 as string | number,
      },
      myPrices: {} as {} | TopUpPrice,
      rules: {
        greatherThan: (value: number) =>
          value >= this.$data.priceReceived ||
          this.$t('validation.must-be-greater-than-equal', {
            value: this.$data.priceReceived,
          }),
        number: (value: string) =>
          number(value) || this.$t('validation.must-be-a-number'),
      },
      total: 0,
      headers: [
        {
          text: this.$t('username'),
          value: 'username',
        },
        {
          text: this.$t('name'),
          value: 'first_name',
        },
        {
          text: this.$t('lastname'),
          value: 'last_name',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: this.$t('price') + ' ($)',
          value: 'price',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
      exitDialog: false,
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
  },
  methods: {
    async getter(params?: Params) {
      const response = await getTopUpAgents({ ...params, not_self: true })
      response.data.results = response.data.results.map(agent => {
        agent.topup_prices = agent.topup_prices.filter(
          price => price.product === this.product.uuid,
        )
        return agent
      })
      return response
    },
    async onRefresh(data: RemoveCreditDTO, item: TopUpAgent) {
      const response = await getTopUpAgentById(item.uuid)
      item.uuid += '///'
      item.topup_credit = response.data.topup_credit
      await this.$nextTick()
      item.uuid = item.uuid.split('///')[0]
    },
    async createConfiguration(user: TopUpAgent): Promise<void> {
      this.editedItem = user
      try {
        const body = {
          agent: user.uuid,
          is_active: true,
          cost: this.mySettings[this.field as 'cost'],
          product: this.product.uuid,
          currency: this.defaultCurrency as 'CUP' | 'USD',
        }
        const response = await createAgentConfiguration(body)
        user.topup_prices.push(response.data)
      } finally {
        this.editedItem = null
      }
    },
    async onChange(item: TopUpAgent) {
      this.editedItem = item
      try {
        await updateAgentPrices({
          uuid: (item.topup_prices[0] as TopUpPrice & { uuid: string }).uuid,
          is_active: (item.topup_prices[0] as TopUpPrice & { uuid: string })
            .is_active,
        })
      } catch (error) {
        item.topup_prices[0].is_active = !item.topup_prices[0].is_active
      } finally {
        this.editedItem = null
      }
    },
  },
  created() {
    if (this.product.code === 'CUCU') {
      this.headers.splice(6, 0, {
        text: this.$t('currency'),
        value: 'currency',
      })
    }
  },
})
